export const STATUS_KINDS = {
  ok:      { bg: 'var(--success-50)', fg: 'var(--success-700)', bd: 'var(--success-200)', dot: 'var(--success-500)' },
  info:    { bg: 'var(--blue-50)',    fg: 'var(--blue-700)',    bd: 'var(--blue-200)',    dot: 'var(--blue-500)'    },
  warn:    { bg: 'var(--warning-50)', fg: 'var(--warning-700)', bd: 'var(--warning-200)', dot: 'var(--warning-500)' },
  err:     { bg: 'var(--error-50)',   fg: 'var(--error-700)',   bd: 'var(--error-200)',   dot: 'var(--error-500)'   },
  neutral: { bg: 'var(--gray-50)',    fg: 'var(--gray-700)',    bd: 'var(--gray-200)',    dot: 'var(--gray-400)'    },
};

const KIND_MAP = {
  completed: 'ok',  success: 'ok',
  running:   'info', creating: 'info', deploying: 'info',
  pending:   'warn', queued: 'warn', branching: 'warn', active: 'warn',
  replicating: 'info',
  errored:   'err',  failed: 'err',
  cancelled: 'neutral', inactive: 'neutral', frozen: 'neutral',
  not_deployed: 'neutral',
  planned:   'neutral', branched: 'neutral',
  testing:   'info',    validating: 'info', releasing: 'info',
  released:  'ok',      deployed:   'ok',
};

const LABELS = {
  completed: 'Completed', success: 'Completed',
  running:   'Running',   creating: 'Running', deploying: 'Deploying',
  pending:   'Pending',   queued: 'Pending',
  replicating: 'Replicating',
  branching: 'Branching', active: 'Active',
  errored:   'Failed',    failed: 'Failed',
  cancelled: 'Cancelled', inactive: 'Inactive', frozen: 'Frozen',
  not_deployed: 'Not deployed',
  planned:   'Planned',   branched: 'Branched',
  testing:   'Testing',   validating: 'Validating', releasing: 'Releasing',
  released:  'Released',  deployed:   'Deployed',
};

export function statusKind(status) {
  return KIND_MAP[status?.toLowerCase()] ?? 'neutral';
}

export function statusTokens(status) {
  return STATUS_KINDS[statusKind(status)];
}

export function statusLabel(status) {
  if (!status) return 'Unknown';
  return LABELS[status.toLowerCase()] ?? status.charAt(0).toUpperCase() + status.slice(1);
}
